import { Directive, ElementRef, EventEmitter, Output, OnDestroy, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[inViewport]',
  standalone: true
})
export class InViewportDirective implements AfterViewInit, OnDestroy {
  @Output() enterViewport = new EventEmitter<void>();
  @Output() exitViewport = new EventEmitter<void>();

  private observer?: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.enterViewport.emit();
        } else {
          this.exitViewport.emit();
        }
      },
      { threshold: 0.55 } // adjust sensitivity
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}